"use client";

import Table from './Table';
export default Table;